import PropTypes from 'prop-types'

import { Spinner, Flex, Box, Text } from '@chakra-ui/react'


function LoadingOverlay({ type, text }) {
    const commonSpinnerProps = {
        thickness: '4px',
        speed: '0.65s',
        size: 'xl',
    }

    const renderOverlay = () => {
        switch (type) {
            case "full":
                return (
                    <Flex
                        position="absolute"
                        top="250px"
                        right="0"
                        bottom="250px"
                        left="0"
                        alignItems="center"
                        justifyContent="center"
                        backgroundColor="rgba(255, 255, 255, 0.8)"
                    >
                        <Box textAlign="center">
                            <Spinner {...commonSpinnerProps} emptyColor="gray.200" color="blue.500" />
                            <Text fontSize="lg" marginTop="3">{text || 'Loading...'}</Text>
                        </Box>
                    </Flex>
                )

            case "component":
                return (
                    <Flex
                        position="fixed"
                        top="0"
                        left="0"
                        right="0"
                        bottom="0"
                        alignItems="center"
                        justifyContent="center"
                        backgroundColor="rgba(0, 0, 0, 0.5)"
                        zIndex="9999"
                    >
                        <Box textAlign="center">
                            <Spinner {...commonSpinnerProps} emptyColor="gray.300" color="green.500" />
                            <Text fontSize="lg" marginTop="3" color="white">{text || 'Processing...'}</Text>
                        </Box>
                    </Flex>
                )

            default:
                console.error('Invalid loading overlay type')
                return null
        }
    }

    return renderOverlay()
}

LoadingOverlay.propTypes = {
    type: PropTypes.oneOf(['full', 'component']).isRequired,
    text: PropTypes.string,
}

export default LoadingOverlay